export enum TimesheetSummaryTypeEnums {
  WEEKLY,
  PAY_PERIOD,
}
